module.exports = __webpack_public_path__ + "media/images/logos/logo_large_wbg-7316377271e1bd28f4defd977b448cfe.jpg";